// extracted by mini-css-extract-plugin
export default {"box":"FieldAnswer_box__9h+kj","container":"FieldAnswer_container__QcgOh","delete":"FieldAnswer_delete__DRtXb"};